import { takeLatest, put } from "redux-saga/effects";
import Actions from "../action";
import { doGet, doPut } from "../../service/index";
import END_POINTS from "./EndPoints";
import {
  GET_SESSION_TIMEOUT,
  UPDATE_SESSION_TIMEOUT,
} from "../action/SessionTimeoutAction";

export function* getSessionTimeoutSaga({ callback }) {
  try {
    const response = yield doGet(END_POINTS.SESSION_TIMEOUT_CONFIG);
    yield put(Actions.getSessionTimeoutSuccessAction(response));
    if (callback) callback(response);
  } catch (error) {
    yield put(Actions.getSessionTimeoutFailureAction({ error }));
    if (callback) callback({ status_code: 1, response: {} });
  }
}

export function* updateSessionTimeoutSaga({ params, callback }) {
  try {
    const response = yield doPut(END_POINTS.SESSION_TIMEOUT_UPDATE, params);
    yield put(Actions.updateSessionTimeoutSuccessAction(response));
    if (callback) callback(response);
  } catch (error) {
    yield put(Actions.updateSessionTimeoutFailureAction({ error }));
    if (callback) callback({ status_code: 1 });
  }
}

export default function* sessionTimeoutWatcher() {
  yield takeLatest(GET_SESSION_TIMEOUT, getSessionTimeoutSaga);
  yield takeLatest(UPDATE_SESSION_TIMEOUT, updateSessionTimeoutSaga);
}
